import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataApiResponseLegacy } from '@digilize/shared/definitions/src/lib/interfaces/DataApiResponseLegacy';
import { AuditLogEntryListModel, GetAuditLogQuery } from '@digilize/shared/definitions/src/lib/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuditLogApiService {
  private readonly BASE_URL = '/api/v1.0/audit-log';

  constructor(private http: HttpClient) {}

  /* Paged change history for one audited record. Like the other lists here the DataTables envelope
     comes back camelCase (`recordsFiltered`) rather than the snake_case swagger documents, hence
     DataApiResponseLegacy.

     Unset filters are dropped rather than sent empty: every filter this endpoint cannot parse is a
     400, so `action=` would turn "no filter chosen" into a validation error. */
  getEntries(params: GetAuditLogQuery): Observable<DataApiResponseLegacy<AuditLogEntryListModel[]>> {
    const query = Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as Record<string, any>);

    return this.http.get<DataApiResponseLegacy<AuditLogEntryListModel[]>>(this.BASE_URL, { params: query });
  }
}
